<template>
  <div class="sign-up3-container1">
    <div class="sign-up3-max-width">
      <div class="sign-up3-container2">
        <img alt="Interior builder working on cutting process" src="../assets/chatgpt image 17 apr 2025, 10_53_01-1500w.png" class="sign-up3-sign-up-image thq-img-ratio-4-6">
      </div>
      <div class="sign-up3-form-root thq-section-padding">
        <div class="sign-up3-form1">
          <div class="sign-up3-title-root" style="padding-top: 30px;">
            <h2 class="thq-heading-2">
              <div class="cssContents">
                <span class="cssInlineBlock">{{ $t('text34') }}</span>
              </div>
            </h2>
            <div class="sign-up3-have-an-account-login">
              <div class="thq-body-large">
                <div class="cssContents">
                  <span class="cssInlineBlock">{{ $t('text35') }}</span>
                </div>
              </div>
            </div>
          </div>
          <form class="sign-up3-form2" @submit.prevent="handleSubmit">
            <div class="sign-up3-email">
              <label for="thq-bedrijf" class="thq-body-large">{{ $t('text36') }}</label>
              <input type="text" id="thq-bedrijf" required="required" class="sign-up3-textinput thq-input thq-body-large" v-model="form.bedrijf">
            </div>
            <div class="sign-up3-email">
              <label for="thq-voornaam" class="thq-body-large">{{ $t('text37') }}</label>
              <input type="text" id="thq-voornaam" required="required" class="sign-up3-textinput thq-input thq-body-large" v-model="form.voornaam">
            </div>
            <div class="sign-up3-email">
              <label for="thq-achternaam" class="thq-body-large">{{ $t('text38') }}</label>
              <input type="text" id="thq-achternaam" required="required" class="sign-up3-textinput thq-input thq-body-large" v-model="form.achternaam">
            </div>
            <div class="sign-up3-email">
              <label for="thq-sign-up-3-email" class="thq-body-large">Email</label>
              <input type="email" id="thq-sign-up-3-email" required="required" class="sign-up3-textinput thq-input thq-body-large" v-model="form.email">
            </div>
            <div class="sign-up3-password">
              <div class="sign-up3-textfield">
                <label for="thq-sign-up-3-password" class="thq-body-large">{{ $t('text39') }}</label>
                <input type="password" id="thq-sign-up-3-password" required="required" class="sign-up3-textinput thq-input thq-body-large" v-model="form.password">
              </div>
              <span class="sign-up3-text15 thq-body-small">
                <div class="cssContents">
                  <span class="cssInlineBlock">{{ $t('text40') }}</span>
                </div>
              </span>
            </div>
            <div class="sign-up3-container4">
              <div class="sign-up3-terms-agree">
                <input type="checkbox" id="thq-sign-up-3-terms" checked="checked" class="thq-checkbox" v-model="form.termsAccepted">
                <label for="thq-sign-up-3-terms" class="thq-body-large">{{ $t('text41') }}</label>
              </div>
            </div>
            <button type="submit" class="thq-button-filled sign-up3-button">
              <span class="sign-up3-text18 thq-body-small">
                <div class="cssContents">
                  <span class="cssInlineBlock">{{ $t('text42') }}</span>
                </div>
              </span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  name: 'Login',
  data() {
    return {
      //baseURL: "http://localhost:8080/MyVlecadOld",
      baseURL: "https://my.vlecad.be/",
      form: {
        bedrijf: '',
        voornaam: '',
        achternaam: '',
        email: '',
        password: '',
        termsAccepted: true
      }
    }
  },
  methods: {
    handleSubmit() {
      console.log("handleSubmit: " + JSON.stringify(this.form));

      if (!this.form.termsAccepted) {
        alert('Je moet de voorwaarden accepteren.');
        return;
      }

      var formData = new FormData();
      //formData.set("company_id", contactId);
      formData.set("company_name", this.form.bedrijf);
      formData.set("firstName", this.form.voornaam);
      formData.set("lastName", this.form.achternaam);
      formData.set("email", this.form.email);
      formData.set("password", this.form.password);
      formData.set("type", "HUUR-AF-MNC");
      
      axios.post(this.baseURL+'api/user/createUserAutofit.php', formData)
      .then(res => {
        console.log(JSON.stringify(res));
        alert('melding: ' + res.data.message);
        //res.data
      })
      .catch(err => {
        console.log("error createUserAutofit: " + err);
        alert('error melding: ' + err);
        //err.response.data
      });
    }
  }
}
</script>
<style scoped>
.sign-up3-container1 {
  width: 100%;
  height: 800px;
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.sign-up3-container2 {
  width: 50%;
  height: 100%;
  display: flex;
  align-self: center;
  align-items: flex-start;
  flex-direction: row;
  justify-content: flex-start;
}

.sign-up3-container3 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}

.sign-up3-container4 {
  gap: var(--dl-layout-space-halfunit);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-end;
}

.sign-up3-max-width {
  height: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}

.sign-up3-sign-up-image {
  width: 100%;
  height: 100%;
}

.sign-up3-form-root {
  gap: var(--dl-layout-space-unit);
  width: 50%;
  height: 100%;
  display: flex;
  overflow: hidden;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
}

.sign-up3-form1 {
  gap: var(--dl-layout-space-oneandhalfunits);
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-end;
}

.sign-up3-form2 {
  gap: var(--dl-layout-space-unit);
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
}

.sign-up3-title-root {
  gap: var(--dl-layout-space-halfunit);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.sign-up3-have-an-account-login {
  gap: var(--dl-layout-space-halfunit);
  display: flex;
  align-items: flex-start;
}

.sign-up3-email {
  gap: var(--dl-layout-space-halfunit);
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-shrink: 0;
  flex-direction: column;
}

.sign-up3-textinput {
  width: 100%;
  border-color: var(--dl-color-theme-primary1);
  background-color: transparent;
}

.sign-up3-password {
  gap: var(--dl-layout-space-halfunit);
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.sign-up3-hide-password {
  gap: var(--dl-layout-space-halfunit);
  width: auto;
  height: auto;
  display: flex;
  align-items: center;
  flex-shrink: 1;
  justify-content: center;
}

.sign-up3-textfield {
  gap: var(--dl-layout-space-halfunit);
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-shrink: 0;
  flex-direction: column;
}

.sign-up3-text15 {
  font-size: 14px;
}

.sign-up3-terms-agree {
  gap: var(--dl-layout-space-halfunit);
  display: flex;
  padding: var(--dl-layout-space-halfunit);
  align-items: center;
}

.sign-up3-newsletter {
  gap: var(--dl-layout-space-halfunit);
  display: flex;
  padding: var(--dl-layout-space-halfunit);
  align-items: center;
}

.sign-up3-text18 {
  text-align: center;
}

@media(max-width: 991px) {
  .sign-up3-container1 {
    gap: var(--dl-layout-space-twounits);
    height: auto;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
  .sign-up3-container2 {
    width: 100%;
    height: var(--dl-layout-size-xxlarge);
  }
  .sign-up3-form-root {
    width: 100%;
  }
}

@media(max-width: 479px) {
  .sign-up3-button {
    width: 100%;
  }
}
</style>
